module.exports = __webpack_public_path__ + "static/media/Oval-border.96b22cfb.svg";